import React from "react";
import { graphql } from "gatsby";
import PropTypes from 'prop-types';
import HtmlBlock from "../../htmlBlock/htmlBlock";
import HubSpot from "../hubspotForm/hubspotForm";
import Link from "../../link/link";

/**
* Renders Hubspot form component / copy
* 
* CMS : DatoCmsComponentFormCopy
*/
const HubSpotContent = ({className, data, mobileButtonClass, loadonscroll, uniqueid, ...other}) => {
  const {mobileButtonText, ...formContent} = data ? data[0] || data : {};
  const {copy, form, heading} = formContent;

  let mobileLink;
  //SET LINK OPTIONS FOR MOBILE LINK POPUP//
  if(mobileButtonText){
    mobileLink = {
      'displayText': mobileButtonText,
      'internalLink' : {
        '__typename': 'DatoCmsComponentModal',
        'content' : formContent
      }
    }
  }

  return (
    <>
      <div className={`${className}`} {...other}>
        {
          heading &&
          <HtmlBlock tag="h2" data={heading} />
        }
        {
          copy &&
          <HtmlBlock className="hubSpot--content__copy" data={copy} />
        }
        {
          form &&
          <HubSpot data={form} loadonscroll={loadonscroll} uniqueid={uniqueid} className={mobileButtonText ? 'tablet-min' : ''}/>
        }
      </div>
      {
        mobileLink && 
        <Link data={mobileLink} className={`${mobileButtonClass || ''} mobile`}/>
      }
    </>
  )
}

HubSpotContent.propTypes = {
  /**
   * Class for section
   */
  className: PropTypes.string,
  /**
   * CMS Data
   */
  data: PropTypes.oneOfType([
    PropTypes.shape({
      copy: PropTypes.string,
      form: PropTypes.object,
      heading: PropTypes.string,
      mobileButtonText: PropTypes.string
    }),
    PropTypes.array
  ]),
   /**
   * Class for mobile button
   */
  mobileButtonClass: PropTypes.string,
  /**
   * Unique identifier
   */
  uniqueid: PropTypes.string,
  loadonscroll: PropTypes.bool
};

HubSpotContent.defaultProps = {
  className: 'hubSpot--content',
}

export default HubSpotContent;

export const HubspotContentFragment = graphql`
  fragment HubspotContentFragment on DatoCmsComponentFormCopy {
    __typename
    copy
    form{
      ...HubspotFragment
    }
    heading
    mobileButtonText
  }`;